import { render, staticRenderFns } from "./updatePost.vue?vue&type=template&id=4a2889a3&scoped=true&"
import script from "./updatePost.vue?vue&type=script&lang=js&"
export * from "./updatePost.vue?vue&type=script&lang=js&"
import style0 from "./updatePost.vue?vue&type=style&index=0&id=4a2889a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2889a3",
  null
  
)

export default component.exports